import React from 'react'
import PropTypes from 'prop-types'

import { withStyles } from '@material-ui/core/styles'

import Image from 'artkive/components/Image'
import ProductDescriptionSection from 'artkive/pages/GetStarted/ProductDescriptionSection'
import theme from 'artkive/utils/theme'

import StorageBadge from 'images/ecom/StorageBadge.svg'

import { Badge, heroStyles } from './KeepsakeHero.style'

const KeepsakeHero = ({ classes, overImage, children, ...rest }) => (
  <ProductDescriptionSection
    descriptionBg={theme.colors.bg.yellow}
    descriptionClassName={classes.description}
    classes={{ wrapper: classes.wrapper }}
    withBubbles
    overImage={
      <>
        <Badge>
          <Image src={StorageBadge} alt='+ 3 Months Storage' />
        </Badge>
        {overImage}
      </>
    }
    {...rest}
  >
    {children}
  </ProductDescriptionSection>
)

KeepsakeHero.propTypes = {
  classes: PropTypes.object.isRequired,
  overImage: PropTypes.node,
  children: PropTypes.node,
}

export default withStyles(heroStyles)(KeepsakeHero)
